import { memo } from 'react'

import { BaseSkeleton } from 'components/BaseSkeleton'

const Component = () => (
  <ul className="zai-hero-pre-prompt-sketons-list">
    {Array.from({ length: 5 }).map((_, index) => (
      <li key={index} className="zai-hero-pre-prompt-sketons-list-item">
        <BaseSkeleton width={`${index <= 2 ? 150 : 310}px`} height="46px" borderRadius="8px" />
      </li>
    ))}
  </ul>
)

export const ZaiHeroSkeletons = memo(Component)
